<template>
  <div class="keenMindDetail">
    <div v-loading="loading"></div>
    <div class="crumb" v-if="clientWidth > 750">
      <breadcrumb :refer="refer"></breadcrumb>
    </div>
    <div class="keenMindDetail-banner">
      <img v-if="keenDetail.banner" :src="keenDetail.banner" alt="">
      <img v-else src="@/assets/PC/keenMind/keendetailbanner.png" alt="">
      <h1 v-if="!keenDetail.banner" class="hidden">{{ keenDetail.title }}</h1>
      <p v-if="!keenDetail.banner" class="flex1"><van-icon name="clock" class="mr co-voi" /> {{ keenDetail.startTimeStr
        }} - {{ keenDetail.endTimeStr }}</p>
    </div>
    <div v-if="keenDetail.classify != 1 && keenDetail.classify != 3">
      <h1 v-if="keenDetail.type == 0" class="keenMindDetail-title">【线上】{{ keenDetail.title }}</h1>
      <h1 v-else class="keenMindDetail-title">【线下】{{ keenDetail.title }}</h1>
    </div>
    <div v-else>
      <h1 class="keenMindDetail-title">{{ keenDetail.title }}</h1>
    </div>
    <div class="flex3 date-signUp">
      <div class="keenMindDetail-date co-999">活动时间： {{ keenDetail.startTimeStr }} - {{ keenDetail.endTimeStr }}</div>
      <div class="signUp flex">

        <div v-if="keenDetail.classify == 0" class="ml10">
          <el-button v-if="keenDetail.status === 2" type="warning" :size="clientWidth > 750 ? '' : 'mini'"
            disabled>已结束</el-button>
          <el-button v-if="keenDetail.status !== 2 && !keenDetail.isSignUp" type="info"
            :size="clientWidth > 750 ? '' : 'mini'" @click="signUp(keenDetail.id)">我要报名</el-button>
          <el-button v-if="keenDetail.status !== 2 && keenDetail.isSignUp" type="warning"
            :size="clientWidth > 750 ? '' : 'mini'" disabled>已报名</el-button>
        </div>

        <div class="flex" v-else-if="keenDetail.classify == 1 || keenDetail.classify == 2">
          <div v-if="keenDetail.isOkEdit && keenDetail.type == 0" class="flex">
            <el-button type="info" :size="clientWidth > 750 ? '' : 'mini'" @click="goActivityPreview">作品展示</el-button>
            <el-button type="info" :size="clientWidth > 750 ? '' : 'mini'" @click="goActivityVote">作品投票</el-button>
          </div>
          <div v-if="keenDetail.status !== 2" class="flex ml10">
            <el-button v-if="!keenDetail.isSignUp" type="info" :size="clientWidth > 750 ? '' : 'mini'"
              @click="goActivitySignUp">我要报名</el-button>
            <el-button v-if="keenDetail.isSignUp && keenDetail.isSubmit == 0 && keenDetail.type == 0" type="info"
              :size="clientWidth > 750 ? '' : 'mini'" @click="goActivityFile">提交作品</el-button>
            <el-button
              v-if="(keenDetail.isSignUp && keenDetail.type == 1) || (keenDetail.isSignUp && keenDetail.isSubmit && keenDetail.type == 0)"
              type="warning" :size="clientWidth > 750 ? '' : 'mini'" disabled>已报名</el-button>
          </div>
          <div v-else class="flex ml10">
            <el-button v-if="keenDetail.status === 2" type="warning" :size="clientWidth > 750 ? '' : 'mini'"
              disabled>已结束</el-button>
          </div>
        </div>

        <div class="flex" v-else-if="keenDetail.classify == 3">
          <div v-if="keenDetail.isOkEdit" class="flex">
            <el-button type="info" :size="clientWidth > 750 ? '' : 'mini'" @click="goActivityPreview">作品展示</el-button>
          </div>
          <div v-if="keenDetail.status !== 2" class="flex ml10">
            <el-button v-if="!keenDetail.isSignUp" type="info" :size="clientWidth > 750 ? '' : 'mini'"
              @click="goActivitySignUp">我要报名</el-button>
            <el-button v-else type="warning" :size="clientWidth > 750 ? '' : 'mini'" disabled>已报名</el-button>
          </div>
          <div v-else class="flex ml10">
            <el-button v-if="keenDetail.status === 2" type="warning" :size="clientWidth > 750 ? '' : 'mini'"
              disabled>已结束</el-button>
          </div>
        </div>

      </div>

    </div>
    <div class="co-999" style="padding: 5px 0 15px 0">{{ keenDetail.introduction }}</div>
    <div v-if="keenDetail.classify != 1 && keenDetail.classify != 3" class="Tag flex4">
      <div v-for="(item, index) in keenDetail.tags" :key="index" class="tag-item">{{ item }}</div>
    </div>
    <div v-html="keenDetail.context" class="description"></div>
    
    <!-- 报名弹框 -->
    <div v-if="showSignAlert" class="sign-alert-shade flex0">
      <div class="sign-alert-content">
        <i class="el-icon-circle-close close-sign-alert cur" @click="closeSignAlert"></i>
        <div v-if="keenDetail.signBanner" class="sign-alert-banner">
          <img :src="keenDetail.signBanner" alt="报名banner" />
        </div>
        
        <!-- 表单内容 -->
        <div v-if="formDetailList && formDetailList.length > 0" class="sign-alert-form">
          <el-form :model="formAnswers" ref="formAnswers" label-width="0">
            <div v-for="(item, index) in formDetailList" :key="item.id" class="form-item-wrapper">
              <!-- 问题标题 -->
              <div class="form-question-title">
                <span v-if="item.isRequired" class="required-mark">*</span>
                {{ item.title }}
              </div>
              
              <!-- 提示文本 -->
              <div v-if="item.noteType === 1 && item.noteText" class="form-note-text">
                {{ item.noteText }}
              </div>
              
              <!-- 提示图片 -->
              <div v-if="item.noteType === 2 && item.noteImage" class="form-note-images">
                <img 
                  v-for="(img, imgIndex) in item.noteImage.split(',')" 
                  :key="imgIndex"
                  :src="img" 
                  alt="提示图片"
                  class="note-image"
                />
              </div>
              
              <!-- 暂时统一使用多行文本框展示所有类型 - 已注释，暂时不使用 -->
              <!-- <el-form-item 
                :prop="`answers.${index}.answer`"
                :rules="item.isRequired ? [{ required: true, message: '请输入' + item.title, trigger: 'blur' }] : []"
              >
                <el-input 
                  v-model="formAnswers.answers[index].answer" 
                  type="textarea"
                  class="form-input-textarea"
                ></el-input>
              </el-form-item> -->
              
              <!-- 单行文本框 -->
              <el-form-item 
                v-if="isTextType(item.type)"
                :prop="`answers.${index}.answer`"
                :rules="item.isRequired ? [{ required: true, message: '请输入' + item.title, trigger: 'blur' }] : []"
              >
                <el-input 
                  v-model="formAnswers.answers[index].answer" 
                  class="form-input-text"
                ></el-input>
              </el-form-item>
              
              <!-- 多行文本框 -->
              <el-form-item 
                v-if="isTextareaType(item.type)"
                :prop="`answers.${index}.answer`"
                :rules="item.isRequired ? [{ required: true, message: '请输入' + item.title, trigger: 'blur' }] : []"
              >
                <el-input 
                  v-model="formAnswers.answers[index].answer" 
                  type="textarea"
                  class="form-input-textarea"
                ></el-input>
              </el-form-item>
              
              <!-- 单选 -->
              <el-form-item 
                v-if="isRadioType(item.type)"
                :prop="`answers.${index}.answer`"
                :rules="item.isRequired ? [{ required: true, message: '请选择' + item.title, trigger: 'change' }] : []"
              >
                <el-radio-group v-model="formAnswers.answers[index].answer" class="radio-group-vertical">
                  <el-radio 
                    v-for="option in item.options" 
                    :key="option.id" 
                    :label="option.title"
                    class="radio-item-block"
                    style="font-weight: normal;"
                  >
                    {{ option.title }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              
              <!-- 多选 -->
              <el-form-item 
                v-if="isCheckboxType(item.type)"
                :prop="`answers.${index}.answer`"
                :rules="item.isRequired ? [{ validator: validateMultiple, trigger: 'change' }] : []"
              >
                <el-checkbox-group v-model="formAnswers.answers[index].answerArray" class="checkbox-group-vertical">
                  <el-checkbox 
                    v-for="option in item.options" 
                    :key="option.id" 
                    :label="option.title"
                    class="checkbox-item-block"
                    style="font-weight: normal;"
                  >
                    {{ option.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              
              <!-- 日期选择 -->
              <el-form-item 
                v-if="isDateType(item.type)"
                :prop="`answers.${index}.answer`"
                :rules="item.isRequired ? [{ required: true, message: '请选择' + item.title, trigger: 'change' }] : []"
              >
                <el-date-picker
                  v-model="formAnswers.answers[index].answer"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  class="form-input-date"
                  :append-to-body="true"
                  :popper-class="'date-picker-popper'"
                ></el-date-picker>
              </el-form-item>
              
              <!-- 上传图片 -->
              <el-form-item 
                v-if="isUploadImageType(item.type)"
                :prop="`answers.${index}.answer`"
                :rules="item.isRequired ? [{ validator: validateFileUpload, trigger: 'change' }] : []"
                style="margin-left:14px;"
                :class="{'upload-limit-reached': formAnswers.answers[index].fileList && formAnswers.answers[index].fileList.length >= 3}"
              >
                <el-upload
                  :action="uploadAction"
                  :headers="uploadHeaders"
                  :file-list="formAnswers.answers[index].fileList"
                  :limit="3"
                  list-type="picture-card"
                  :on-success="(response, file, fileList) => handleUploadSuccess(response, file, fileList, index)"
                  :on-remove="(file, fileList) => handleUploadRemove(file, fileList, index)"
                  :before-upload="(file) => handleBeforeUpload(file, item.fileType, true, index)"
                  :on-exceed="handleExceedLimit"
                  :class="['image-upload-component', {'upload-limit-reached': formAnswers.answers[index].fileList && formAnswers.answers[index].fileList.length >= 3}]"
                >
                  <i v-if="!formAnswers.answers[index].fileList || formAnswers.answers[index].fileList.length < 3" class="el-icon-plus"></i>
                </el-upload>
                <div class="el-upload__tip" style="margin-top: 10px; color: #999; font-size: 12px;">
                  最多上传3张图片
                </div>
              </el-form-item>
              
              <!-- 上传文件 -->
              <el-form-item 
                v-if="isUploadFileType(item.type)"
                :prop="`answers.${index}.answer`"
                :rules="item.isRequired ? [{ validator: validateFileUpload, trigger: 'change' }] : []"
                style="margin-left:14px;"
                :class="{'file-upload-limit-reached': formAnswers.answers[index].fileList && formAnswers.answers[index].fileList.length >= 1}"
              >
                <el-upload
                  :action="uploadAction"
                  :headers="uploadHeaders"
                  :file-list="formAnswers.answers[index].fileList"
                  :limit="1"
                  :on-success="(response, file, fileList) => handleUploadSuccess(response, file, fileList, index)"
                  :on-remove="(file, fileList) => handleUploadRemove(file, fileList, index)"
                  :before-upload="(file) => handleBeforeUpload(file, item.fileType, false, index)"
                  :on-exceed="handleExceedLimit"
                  :class="['file-upload-component', {'file-upload-limit-reached': formAnswers.answers[index].fileList && formAnswers.answers[index].fileList.length >= 1}]"
                >
                  <el-button 
                    v-if="!formAnswers.answers[index].fileList || formAnswers.answers[index].fileList.length < 1" 
                    size="small" 
                    type="primary"
                  >
                    点击上传
                  </el-button>
                  <div slot="tip" class="el-upload__tip">
                    最多上传1个文件
                  </div>
                </el-upload>
              </el-form-item>
            </div>
            
            <!-- 提交按钮 -->
            <div class="form-submit-btn">
              <el-button type="primary" :loading="submitLoading" @click="submitForm">提交</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/Breadcrumb/index.vue";
import { common_msg_update, GetWxShares } from "@/utils/common.js";
import * as Keen from '@/api/KeenMind.js';
import { dataState } from "@/api/all.js";
import { ApiToken } from '@/utils/ApiToken';

export default {
  name: "keenMindDetail",
  data() {
    return {
      refer: [
        { name: "首页", href: "/" },
        { name: "剑鸣", href: "/Home/keenMind" },
      ],
      loading: true,                          // !loading
      keenDetail: {},                          // !详情页数据
      showSignAlert: false,                    // !是否显示报名弹框
      formDetailList: [],                      // !表单问题列表
      formAnswers: {                          // !表单答案
        answers: []
      },
      submitLoading: false,                    // !提交loading
      uploadAction: '',                        // !文件上传地址
      uploadHeaders: {},                       // !文件上传请求头
      // 表单组件类型常量
      FORM_TYPES: {
        TEXT: '366090ad-2aeb-4241-a594-dbb4d3f7058b',           // 文本框（单行）
        TEXTAREA: '573206f8-54be-4097-a055-0a53b504bc4d',        // 多行文本
        RADIO: 'a9c41925-2d31-4434-8007-abf99158050b',          // 单选
        CHECKBOX: '61ddce3b-9768-4cb4-9a7f-9fe16d5cb3e8',       // 多选
        DATE: '5d27768d-beba-479e-a0a3-844ac31dcbec',           // 日期
        UPLOAD_IMAGE: '4405b0e8-fe5b-406e-a570-79eeec12c8f1',   // 上传图片
        UPLOAD_FILE: '039ba1b1-f7d4-4842-8fe2-1391cb18067d'     // 上传文件
      }
    }
  },
  mounted() {
    if (!this.$route.query.id) {
      this.$toast('页面异常，正在返回首页');
      setTimeout(() => {
        this.$router.push('/Home/keenMind');
      }, 500);
      return false;
    }
    // 初始化文件上传配置
    this.uploadAction = ApiToken.baseApi + '/Files/UploadAzureBlob';
    this.uploadHeaders = {
      'Authorization': 'Bearer ' + (this.$store.state.token || '')
    };
    this.Init();
    // 数据统计
    const data = {
      "visitType": 1,
      "gid": sessionStorage.getItem('gid') ? sessionStorage.getItem('gid') : '',
      "url": window.location.href,
      "pageUrl": "keenMindDetail",
      "relationId": this.$route.query.id,
    }
    dataState(data).then(res => {
      sessionStorage.setItem('gid', res.data);
    });
  },
  methods: {
    // !获取详情数据
    Init() {
      const Id = { id: this.$route.query.id }
      Keen.GetActivityDetail(Id).then(res => {
        if (res.status == 1) {
          this.keenDetail = res.data;
          if (this.refer.length < 3) {
            this.refer.push({ 'name': res.data.title })
          }
          const share = {
            title: res.data.title,
            desc: ''
          }
          GetWxShares(share);
          // 检查是否需要显示报名弹框
          this.checkSignAlert();
        } else {
          this.$toast(res.message);
          this.$router.push('/Home/keenMind');

        }
        this.loading = false;
      })
    },
    
    // !检查是否需要显示报名弹框
    checkSignAlert() {
      // 检查用户是否登录
      if (!this.$store.state.token) {
        return;
      }
      
      // 检查是否已报名  未报名或未开启反馈问卷或未开启问卷 不展示弹框
      if (!this.keenDetail.isSignUp || !this.keenDetail.hasSign) {
        return;
      }
      // 未提交过问卷
      if (!this.keenDetail.isSign) {
        // 获取表单详情
        this.getFormDetail();
        this.showSignAlert = true;
      }

    },
    
    // !获取表单详情
    getFormDetail() {
      const activityId = this.$route.query.id;
      Keen.GetFormDetail({ id: activityId }).then(res => {
        if (res.status == 1) {
          this.formDetailList = res.data || [];
          console.log('表单问题列表:', this.formDetailList);
          // 初始化表单答案
          this.initFormAnswers();
          // 确保所有上传类型的删除按钮可见
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.formDetailList.forEach((item, index) => {
                if (this.isUploadImageType(item.type)) {
                  this.ensureDeleteButtonsVisible(index);
                }
              });
            });
          });
        } else {
          console.error('获取表单详情失败:', res.message);
        }
      }).catch(err => {
        console.error('获取表单详情异常:', err);
      });
    },
    
    // !初始化表单答案
    initFormAnswers() {
      this.formAnswers.answers = this.formDetailList.map(item => {
        return {
          id: item.id,
          question: item.title,
          answer: item.options && item.options.length > 0 ? '' : '',
          answerArray: [], // 用于多选
          fileList: [], // 用于文件上传
          isShow: true
        };
      });
    },
    
    // !提交表单
    submitForm() {
      this.$refs.formAnswers.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          
          const activityId = this.$route.query.id;
          const answers = this.formAnswers.answers.map((item, idx) => {
            // 暂时统一使用文本答案
            let answer = item.answer || '';
            
            // 判断问题类型 - 已注释，暂时不使用
            const formItem = this.formDetailList[idx];
            if (formItem && (this.isUploadImageType(formItem.type) || this.isUploadFileType(formItem.type))) {
              // 文件上传类型 - 图片用逗号拼接
              if (item.fileList && item.fileList.length > 0) {
                answer = item.fileList.map(file => {
                  return file.response?.data?.fileUrl || file.response?.url || file.url || '';
                }).filter(url => url).join(',');
              }
            } else if (formItem && this.isCheckboxType(formItem.type)) {
              // 多选类型
              if (item.answerArray && item.answerArray.length > 0) {
                answer = item.answerArray.join('&&');
              }
            } else {
              // 文本输入、单选、日期等
              answer = item.answer || '';
            }
            
            return {
              id: item.id,
              question: item.question,
              answer: answer,
              isShow: item.isShow !== false
            };
          });
          
          const submitData = {
            relationId: activityId,
            answers: answers
          };
          
          Keen.SubmitForm(submitData).then(res => {
            this.submitLoading = false;
            if (res.status === 1) {
              this.$toast('提交成功！');
              // 记录已提交状态
              const closedKey = `signAlertClosed_${activityId}`;
              localStorage.setItem(closedKey, 'true');
              this.closeSignAlert();
              // 刷新页面数据
              this.Init();
            } else {
              console.log('提交表单失败:', res.message);
              const errorMessage = (res.message && res.message.trim()) ? res.message : '提交失败，请重试';
              this.$toast(errorMessage);
            }
          }).catch(err => {
            this.submitLoading = false;
            console.error('提交表单异常:', err);
            this.$toast('提交失败，请重试');
          });
        } else {
          this.$toast('请完善表单信息');
        }
      });
    },
    
    // !文件上传成功回调
    handleUploadSuccess(response, file, fileList, index) {
      // 处理文件上传响应，确保文件列表格式正确
      const fileUrl = response.data?.fileUrl || response.url || '';
      const fileItem = {
        name: file.name,
        url: fileUrl,
        uid: file.uid,
        response: response
      };
      
      // 更新文件列表
      this.formAnswers.answers[index].fileList = fileList.map(f => {
        if (f.uid === file.uid) {
          return fileItem;
        }
        // 保持已有文件的格式
        return {
          name: f.name,
          url: f.url || f.response?.data?.fileUrl || f.response?.url || '',
          uid: f.uid,
          response: f.response
        };
      });
      
      // 判断是图片上传还是文件上传
      const formItem = this.formDetailList[index];
      const isImage = formItem && this.isUploadImageType(formItem.type);
      
      // 确保所有删除按钮正常显示
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.ensureDeleteButtonsVisible(index);
          
          if (isImage) {
            // 图片上传：如果达到3张，确保上传按钮框被隐藏
            if (this.formAnswers.answers[index].fileList.length >= 3) {
              this.hideUploadButton(index);
            }
          } else {
            // 文件上传：如果达到1个，隐藏上传按钮
            if (this.formAnswers.answers[index].fileList.length >= 1) {
              this.hideFileUploadButton(index);
            }
          }
        });
      });
    },
    
    // !文件删除回调
    handleUploadRemove(file, fileList, index) {
      this.formAnswers.answers[index].fileList = fileList;
      
      // 判断是图片上传还是文件上传
      const formItem = this.formDetailList[index];
      const isImage = formItem && this.isUploadImageType(formItem.type);
      
      // 确保删除按钮可见
      this.$nextTick(() => {
        this.ensureDeleteButtonsVisible(index);
        
        if (isImage) {
          // 图片上传：如果删除后少于3张，显示上传按钮
          if (fileList.length < 3) {
            this.showUploadButton(index);
          }
        } else {
          // 文件上传：如果删除后少于1个，显示上传按钮
          if (fileList.length < 1) {
            this.showFileUploadButton(index);
          }
        }
      });
    },
    
    // !隐藏文件上传按钮
    hideFileUploadButton(index) {
      this.$nextTick(() => {
        const formItem = document.querySelectorAll('.file-upload-component')[index];
        if (formItem) {
          const uploadButton = formItem.querySelector('.el-button');
          if (uploadButton) {
            uploadButton.style.display = 'none';
            uploadButton.style.visibility = 'hidden';
          }
        }
      });
    },
    
    // !显示文件上传按钮
    showFileUploadButton(index) {
      this.$nextTick(() => {
        const formItem = document.querySelectorAll('.file-upload-component')[index];
        if (formItem) {
          const uploadButton = formItem.querySelector('.el-button');
          if (uploadButton) {
            uploadButton.style.display = '';
            uploadButton.style.visibility = '';
          }
        }
      });
    },
    
    // !确保删除按钮可见
    ensureDeleteButtonsVisible(index) {
      // 查找对应的上传组件
      const uploadComponents = document.querySelectorAll('.image-upload-component');
      if (uploadComponents[index]) {
        const uploadComponent = uploadComponents[index];
        
        // 查找所有上传列表项
        const uploadItems = uploadComponent.querySelectorAll('.el-upload-list__item');
        if (uploadItems && uploadItems.length > 0) {
          uploadItems.forEach((item, itemIndex) => {
            // 确保列表项有相对定位
            item.style.position = 'relative';
            
            // 查找删除按钮 - 尝试多种可能的类名
            let deleteBtn = item.querySelector('.el-upload-list__item-delete') ||
                           item.querySelector('.el-icon-close') ||
                           item.querySelector('.el-icon-delete') ||
                           item.querySelector('[class*="delete"]') ||
                           item.querySelector('[class*="remove"]') ||
                           item.querySelector('[class*="close"]');
            
            // 如果没找到，尝试查找包含删除图标的元素
            if (!deleteBtn) {
              const icons = item.querySelectorAll('i');
              icons.forEach(icon => {
                if (icon.classList.contains('el-icon-close') || 
                    icon.classList.contains('el-icon-delete') ||
                    icon.classList.contains('el-icon-circle-close')) {
                  deleteBtn = icon.parentElement || icon;
                }
              });
            }
            
            // 如果还是没找到，尝试查找所有可能的删除按钮元素
            if (!deleteBtn) {
              const possibleDeleteBtns = item.querySelectorAll('span, div, i');
              possibleDeleteBtns.forEach(elem => {
                if (elem.classList && (
                    elem.classList.contains('el-upload-list__item-delete') ||
                    elem.classList.contains('el-icon-close') ||
                    elem.classList.contains('el-icon-delete') ||
                    elem.getAttribute('title') === '删除' ||
                    elem.getAttribute('aria-label') === '删除'
                  )) {
                  deleteBtn = elem;
                }
              });
            }
            
            // 如果找到了删除按钮，确保它可见
            if (deleteBtn) {
              deleteBtn.style.display = 'block';
              deleteBtn.style.opacity = '1';
              deleteBtn.style.visibility = 'visible';
              deleteBtn.style.pointerEvents = 'auto';
              deleteBtn.style.zIndex = '10';
              deleteBtn.style.cursor = 'pointer';
            } else {
              // 如果没找到，可能需要手动创建或显示
              console.log('未找到删除按钮，item:', item);
            }
          });
        }
      }
    },
    
    // !隐藏上传按钮框
    hideUploadButton(index) {
      this.$nextTick(() => {
        // 查找对应的上传组件 - 使用更精确的选择器
        const formItem = document.querySelectorAll('.el-form-item.upload-limit-reached')[index] || 
                        document.querySelectorAll('.form-item-wrapper')[index];
        
        if (formItem) {
          // 隐藏上传按钮框
          const uploadButton = formItem.querySelector('.el-upload--picture-card');
          if (uploadButton) {
            uploadButton.style.display = 'none';
            uploadButton.style.visibility = 'hidden';
            uploadButton.style.opacity = '0';
            uploadButton.style.height = '0';
            uploadButton.style.width = '0';
            uploadButton.style.margin = '0';
            uploadButton.style.padding = '0';
          }
        }
        
        // 再次确保删除按钮可见
        this.ensureDeleteButtonsVisible(index);
      });
    },
    
    // !显示上传按钮框
    showUploadButton(index) {
      this.$nextTick(() => {
        const formItem = document.querySelectorAll('.el-form-item')[index] || 
                        document.querySelectorAll('.form-item-wrapper')[index];
        
        if (formItem) {
          const uploadButton = formItem.querySelector('.el-upload--picture-card');
          if (uploadButton) {
            uploadButton.style.display = '';
            uploadButton.style.visibility = '';
            uploadButton.style.opacity = '';
            uploadButton.style.height = '';
            uploadButton.style.width = '';
            uploadButton.style.margin = '';
            uploadButton.style.padding = '';
          }
        }
      });
    },
    
    // !文件上传前验证
    handleBeforeUpload(file, allowedTypes, isImage = false, index = null) {
      // 检查数量限制
      if (index !== null) {
        const currentFileList = this.formAnswers.answers[index].fileList || [];
        if (isImage) {
          // 图片上传限制为3张
          if (currentFileList.length >= 3) {
            this.$toast('最多只能上传3张图片');
            return false;
          }
        } else {
          // 文件上传限制为1个
          if (currentFileList.length >= 1) {
            this.$toast('最多只能上传1个文件');
            return false;
          }
        }
      }
      
      if (!allowedTypes) {
        // 如果是图片上传但没有指定类型，默认允许常见图片格式
        if (isImage) {
          const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
          const fileExtension = file.name.split('.').pop().toLowerCase();
          if (!imageExtensions.includes(fileExtension)) {
            this.$toast('请上传图片文件（jpg、png、gif等格式）');
            return false;
          }
        }
        return true;
      }
      
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const allowedExtensions = allowedTypes.split(',').map(type => type.trim().toLowerCase());
      
      if (!allowedExtensions.includes(fileExtension)) {
        this.$toast(`文件类型不支持，仅支持：${allowedTypes}`);
        return false;
      }
      
      return true;
    },
    
    // !处理超出上传限制
    handleExceedLimit(files, fileList) {
      // 判断是图片还是文件上传
      const isImageUpload = fileList.some(file => {
        const ext = file.name?.split('.').pop()?.toLowerCase() || '';
        return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
      });
      
      if (isImageUpload) {
        this.$toast('最多只能上传3张图片，请先删除部分图片后再上传');
      } else {
        this.$toast('最多只能上传1个文件，请先删除文件后再上传');
      }
    },
    
    // !判断组件类型的方法
    isTextType(type) {
      return type === this.FORM_TYPES.TEXT;
    },
    isTextareaType(type) {
      return type === this.FORM_TYPES.TEXTAREA;
    },
    isRadioType(type) {
      return type === this.FORM_TYPES.RADIO;
    },
    isCheckboxType(type) {
      return type === this.FORM_TYPES.CHECKBOX;
    },
    isDateType(type) {
      return type === this.FORM_TYPES.DATE;
    },
    isUploadImageType(type) {
      return type === this.FORM_TYPES.UPLOAD_IMAGE;
    },
    isUploadFileType(type) {
      return type === this.FORM_TYPES.UPLOAD_FILE;
    },
    // !判断是否为多选类型（兼容旧代码）
    isMultipleType(type) {
      return type === this.FORM_TYPES.CHECKBOX;
    },
    
    // !多选验证
    validateMultiple(rule, value, callback) {
      const fieldParts = rule.field.split('.');
      if (fieldParts.length >= 3) {
        const index = parseInt(fieldParts[1]);
        const item = this.formDetailList[index];
        if (item && item.isRequired && (!this.formAnswers.answers[index].answerArray || this.formAnswers.answers[index].answerArray.length === 0)) {
          callback(new Error('请选择' + item.title));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    
    // !文件上传验证
    validateFileUpload(rule, value, callback) {
      const fieldParts = rule.field.split('.');
      if (fieldParts.length >= 3) {
        const index = parseInt(fieldParts[1]);
        const item = this.formDetailList[index];
        if (item && item.isRequired && (!this.formAnswers.answers[index].fileList || this.formAnswers.answers[index].fileList.length === 0)) {
          callback(new Error('请上传' + item.title));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    
    // !关闭报名弹框
    closeSignAlert() {
      this.showSignAlert = false;
    },

    // !我要报名
    signUp(id) {
      const Id = { "activityId": id }
      if (this.$store.state.token) {
        Keen.SignUp(Id).then(res => {
          this.$toast(res.message);
          if (res.status == 1) {
            this.Init();
          } else {
            
          }
        }).then(() => {
          common_msg_update();
        })
      } else {
        this.$toast('请先登录后再来报名吧！');
        if (this.$route.path.includes('keenMindDetail')) {
          sessionStorage.setItem("Fence", this.$route.path + '?id=' + this.$route.query.id)
        }
        setTimeout(() => {
          // this.$router.push('/Login');
          this.$router.push('/Login?redirectUrl=' + this.$route.fullPath);
        }, 500)
      }
    },
    // !去活动报名页面
    goActivitySignUp() {
      if (this.$store.state.token) {
        this.$router.push('/Home/ActivitySignUp?id=' + this.$route.query.id);
      } else {
        this.$toast('请先登录后再来报名吧！');
        if (this.$route.path.includes('keenMindDetail')) {
          sessionStorage.setItem("Fence", this.$route.path + '?id=' + this.$route.query.id)
        }
        setTimeout(() => {
          this.$router.push('/Login?redirectUrl=' + this.$route.fullPath);
        }, 500)
      }
    },
    // !去提交作品页面
    goActivityFile() {
      this.$router.push('/Home/ActivityFile?id=' + this.$route.query.id);
    },
    // !去作品展示页面
    goActivityPreview() {
      this.$router.push('/Home/ActivityPreview?id=' + this.$route.query.id);
    },
    // !去作品投票页面
    goActivityVote() {
      this.$router.push('/Home/ActivityVote?id=' + this.$route.query.id);
    }
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
  components: {
    breadcrumb,
  },
}
</script>

<style lang="scss">
$mobil_base: 750;

@function vw($true) {
  @return ($true / $mobil_base) * 100vw;
}

.keenMindDetail {
  .keenMindDetail-title {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .date-signUp {
    margin-bottom: 23px;
  }

  .keenMindDetail-date {
    font-size: 16px;
  }

  .Tag {
    margin-bottom: 40px;
  }

  .el-button--warning.is-disabled {
    background: #909399;
    border-color: #909399;
  }
}

@media (max-width: 750px) {
  .keenMindDetail {
    .keenMindDetail-title {
      font-size: vw(32);
      margin: vw(39) 0 vw(24) 0;
    }

    .date-signUp {
      display: block;
      margin-bottom: vw(41);
    }

    .keenMindDetail-date {
      font-size: vw(24);
      margin-bottom: vw(30);
    }

    .Tag {
      margin-bottom: vw(40)
    }
  }
}

// 报名弹框样式
.sign-alert-shade {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100000001 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sign-alert-content {
  position: relative;
  width: 814px;
  max-width: 90%;
  max-height: 90vh;
  background: #fff;
  border-radius: 0;
  overflow: visible;
  display: flex;
  flex-direction: column;
  z-index: 100000002 !important;
}

.close-sign-alert {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  z-index: 10;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    opacity: 0.8;
  }
}

.sign-alert-banner {
  display: block;
  width: 100%;
  height: 300px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 300px;
    display: block;
    object-fit: cover;
  }
}

@media (max-width: 750px) {
  .sign-alert-content {
    width: calc(100% - 40px);
    max-width: calc(100% - 40px);
  }
  
  .close-sign-alert {
    font-size: vw(36);
    right: vw(10);
    top: vw(10);
  }
  
  .sign-alert-banner {
    height: auto;
    
    img {
      height: auto;
      max-height: none;
    }
  }
}

// 表单样式
.sign-alert-form {
  padding: 0;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: visible;
  position: relative;
  flex: 1;
  z-index: 100000002 !important;
  
  // 确保 el-form-item 没有多余的 margin
  .el-form-item {
    margin-bottom: 0;
    position: relative;
    z-index: 100000002 !important;
    
    .el-form-item__content {
      margin-left: 0 !important;
      position: relative;
      z-index: 100000002 !important;
    }
  }
}

.form-item-wrapper {
  margin-bottom: 0;
  padding: 0 155px;
  
  &:first-child {
    padding-top: 40px;
  }
  
  &:not(:first-child) {
    padding-top: 30px;
  }
}

.form-question-title {
  font-size: 16px;
  margin-bottom: 12px;
  color: #000000;
  .required-mark {
    color: #f56c6c;
    margin-right: 4px;
  }
}

.form-note-text {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.5;
}

// 输入框样式
.form-input-text {
  width: 504px;
  margin-left:14px;
  .el-input__inner {
    height: 37px;
    font-size: 16px;
    color: #000000;
    border: 0.5px solid #9d9d9d;
  }
}

.form-input-textarea {
  width: 504px;
  margin-left:14px;
  .el-textarea__inner {
    min-height: 139px;
    height: 139px;
    font-size: 16px;
    color: #000000;
    border: 0.5px solid #9d9d9d;
    padding: 12px;
  }
}

.form-input-date {
  width: 504px;
  margin-left:14px;
  .el-input__inner {
    height: 37px;
    font-size: 16px;
    color: #000000;
    border: 0.5px solid #9d9d9d;
    cursor: pointer;
  }
  
  .el-input__suffix {
    cursor: pointer;
  }
}

// 日期选择器下拉面板样式
.date-picker-popper {
  z-index: 100000003 !important;
}

.form-note-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
  
  .note-image {
    max-width: 200px;
    max-height: 200px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }
}

// 单选和多选样式 - 横向排列（按设计图）
.radio-group-vertical {
  margin-left:14px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  
  .radio-item-block {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 0;
    
    .el-radio__inner {
      width: 17px;
      height: 17px;
      border-width: 0.5px;
      border-color: #9d9d9d;
    }
    .el-radio {
      font-weight: 0 !important;
      display: flex;
      align-items: center;
    }
    .el-radio__label {
      font-size: 16px;
      color: #000000;
      padding-left: 8px;
    }
    
    &:last-child {
      margin-right: 0;
    }
  }
}

.checkbox-group-vertical {
  margin-left:14px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  
  .checkbox-item-block {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 0;
    
    .el-checkbox__inner {
      width: 17px;
      height: 17px;
      border-width: 0.5px;
      border-color: #9d9d9d;
    }
    .el-checkbox__inner::after {
        left: 6px;
        top: 2px;
    }
    
    .el-checkbox__label {
      font-size: 16px;
      color: #000000;
      padding-left: 8px;
    }
    
    &:last-child {
      margin-right: 0;
    }
  }
}

  .form-submit-btn {
    margin-top: 48px;
    margin-bottom: 52px;
    text-align: center;
    
     .el-button {
      width: 188px;
      height: 52px;
      font-size: 20px !important;
      background-color: #6b18a8;
      border-color: #6b18a8;
      
      span,
      .el-button__inner {
        font-size: 20px !important;
      }
      
      &:hover {
        background-color: #5a1488;
        border-color: #5a1488;
      }
    }
  }
  
  // 隐藏达到限制时的上传按钮框 - 最直接的方法
  // 只隐藏上传按钮，不影响删除按钮
  .upload-limit-reached {
    /deep/ .el-upload--picture-card {
      display: none !important;
    }
    
    // 确保删除按钮正常显示 - 使用多种选择器
    /deep/ .el-upload-list__item-delete,
    /deep/ .el-upload-list__item .el-icon-close,
    /deep/ .el-upload-list__item .el-icon-delete,
    /deep/ .el-upload-list__item .el-icon-circle-close {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      z-index: 10 !important;
      cursor: pointer !important;
    }
    
    // 确保列表项有相对定位
    /deep/ .el-upload-list__item {
      position: relative !important;
    }
  }
  
  // 当上传组件有 upload-limit-reached class 时，隐藏上传按钮
  /deep/ .image-upload-component.upload-limit-reached .el-upload--picture-card {
    display: none !important;
  }
  
  // 确保删除按钮正常显示（所有已上传的图片）
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    position: relative !important;
    
    // 删除按钮的标准类名
    .el-upload-list__item-delete {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      z-index: 10 !important;
      cursor: pointer !important;
    }
    
    // 可能的删除图标类名
    .el-icon-close,
    .el-icon-delete,
    .el-icon-circle-close {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      z-index: 10 !important;
      cursor: pointer !important;
    }
    
    // 确保包含删除图标的父元素也可见
    [class*="delete"],
    [class*="remove"],
    [class*="close"] {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      z-index: 10 !important;
    }
  }
  
  // 全局确保所有删除按钮可见
  /deep/ .el-upload-list__item-delete,
  /deep/ .el-upload-list__item .el-icon-close,
  /deep/ .el-upload-list__item .el-icon-delete,
  /deep/ .el-upload-list__item .el-icon-circle-close {
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: auto !important;
    z-index: 10 !important;
    cursor: pointer !important;
  }
  
  // 当文件列表有3个时，隐藏上传按钮（Element UI 的 limit 机制）
  /deep/ .el-upload-list--picture-card {
    .el-upload-list__item:nth-child(3) ~ .el-upload--picture-card {
      display: none !important;
    }
  }
  
  // 确保达到 limit 时隐藏上传按钮，但不影响删除按钮
  /deep/ .el-upload-list--picture-card .el-upload-list__item:nth-child(3) {
    & ~ .el-upload--picture-card {
      display: none !important;
    }
    
    // 确保第三个图片的删除按钮正常显示
    .el-upload-list__item-delete {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
    }
  }
  
  // 在 form-item 上的 upload-limit-reached class
  .form-item-wrapper.upload-limit-reached,
  .el-form-item.upload-limit-reached {
    /deep/ .el-upload--picture-card {
      display: none !important;
    }
    
    // 确保删除按钮正常显示
    /deep/ .el-upload-list__item-delete {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      z-index: 10 !important;
    }
    
    // 确保所有上传列表项都有相对定位
    /deep/ .el-upload-list__item {
      position: relative !important;
    }
  }
  
  // 通用规则：确保所有上传组件中的删除按钮都可见
  /deep/ .image-upload-component {
    .el-upload-list__item {
      position: relative !important;
    }
    
    // 删除按钮的标准类名和可能的变体
    .el-upload-list__item-delete,
    .el-upload-list__item .el-icon-close,
    .el-upload-list__item .el-icon-delete,
    .el-upload-list__item .el-icon-circle-close {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      z-index: 10 !important;
      cursor: pointer !important;
    }
    
    // 确保所有可能的删除相关元素都可见
    [class*="delete"],
    [class*="remove"],
    [class*="close"] {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      z-index: 10 !important;
    }
  }

@media (max-width: 750px) {
  .sign-alert-form {
    padding: vw(30);
    max-height: 50vh;
  }
  
  .form-item-wrapper {
    padding: 0 vw(20) !important;
    &:not(:first-child) {
      padding-top: vw(40) !important;
    }
  }
  
  .form-question-title {
    font-size: vw(28);
    margin-bottom: vw(24);
  }
  
  .form-note-text {
    font-size: vw(24);
    margin-bottom: vw(24);
  }
  
  .form-note-images {
    gap: vw(20);
    margin-bottom: vw(20);
    
    .note-image {
      max-width: vw(200);
      max-height: vw(200);
    }
  }
  
  .form-input-text {
    width: 100% !important;
    
    .el-input__inner {
      height: vw(74);
      font-size: vw(32);
    }
  }
  
  .form-input-textarea {
    width: 100% !important;
    
    .el-textarea__inner {
      min-height: vw(278);
      height: vw(218);
      font-size: vw(32);
      padding: vw(24);
    }
  }
  
  .radio-group-vertical {
    margin-left:14px;
    flex-direction: column;
    
    .radio-item-block {
      margin-right: 0;
      margin-bottom: vw(20);
    }
  }
  
  .checkbox-group-vertical {
    margin-left:14px;
    flex-direction: column;
    
    .checkbox-item-block {
      margin-right: 0;
      margin-bottom: vw(20);
    }
  }
  
  .form-submit-btn {
    margin-top: vw(96);
    margin-bottom: vw(104);
    
    .el-button {
      width: vw(500);
      height: vw(80);
      font-size: vw(32);
    }
  }
}

// 确保 toast 提示在弹窗之上显示
.van-toast {
  z-index: 100000005 !important;
}

// 文件上传按钮隐藏样式
.file-upload-limit-reached {
  /deep/ .el-button {
    display: none !important;
  }
}

.file-upload-component.file-upload-limit-reached {
  /deep/ .el-button {
    display: none !important;
  }
}

.el-form-item.file-upload-limit-reached {
  /deep/ .el-button {
    display: none !important;
  }
}
</style>